const albums2021 = [
  {
    id: 1,
    title: {
      english: "Qualified Worker Award Distribution Ceremony 2021 (Awardees - 2015 and 2017)",
      marathi: "गुणवंत कामगार पुरस्कार वितरण सोहळा २०२१ ( पुरस्कार्थी - सन २०१५ व २०१७ )"
    },
    year: 2021,
    photos: [
      {
        id: 1,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M1.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M1.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M1.jpg"
      },
      {
        id: 2,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M2.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M2.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M2.jpg"
      },
      {
        id: 3,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M3.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M3.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M3.jpg"
      },
      {
        id: 4,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M4.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M4.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M4.jpg"
      },
      {
        id: 5,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M5.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M5.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M5.jpg"
      },
      {
        id: 6,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M6.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M6.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M6.jpg"
      },
      {
        id: 7,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M7.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M7.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M7.jpg"
      },
      {
        id: 8,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M8.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M8.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M8.jpg"
      },
      {
        id: 9,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M9.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M9.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M9.jpg"
      },
      {
        id: 10,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M10.jpg"
      },
      {
        id: 11,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M11.jpg"
      },
      {
        id: 12,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M12.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M12.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M12.jpg"
      },
      {
        id: 13,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M13.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M13.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M13.jpg"
      },
      {
        id: 14,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M14.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M14.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M14.jpg"
      },
      {
        id: 15,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M15.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M15.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M15.jpg"
      },
      {
        id: 16,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M16.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M16.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M16.jpg"
      },
      {
        id: 17,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M17.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M17.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M17.jpg"
      },
      {
        id: 18,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M18.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M18.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M18.jpg"
      },
      {
        id: 19,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M19.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M19.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M19.jpg"
      },
      {
        id: 20,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M20.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M20.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M20.jpg"
      },
      {
        id: 21,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M21.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M21.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M21.jpg"
      },
      {
        id: 22,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M22.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M22.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M22.jpg"
      },
      {
        id: 23,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M23.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M23.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M23.jpg"
      },
      {
        id: 24,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M24.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M24.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M24.jpg"
      },
      {
        id: 25,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M25.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M25.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M25.jpg"
      },
      {
        id: 26,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M26.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M26.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M26.jpg"
      },
      {
        id: 27,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M27.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M27.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M27.jpg"
      },
      {
        id: 28,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M28.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M28.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M28.jpg"
      },
      {
        id: 29,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M29.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M29.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M29.jpg"
      },
      {
        id: 30,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M30.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M30.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M30.jpg"
      },
      {
        id: 31,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M31.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M31.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M31.jpg"
      },
      {
        id: 32,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M32.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M32.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M32.jpg"
      },
      {
        id: 33,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M33.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M33.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M33.jpg"
      },
      {
        id: 34,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M34.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M34.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M34.jpg"
      },
      {
        id: 35,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M35.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M35.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M35.jpg"
      },
      {
        id: 36,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M36.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M36.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M36.jpg"
      },
      {
        id: 37,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M37.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M37.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M37.jpg"
      },
      {
        id: 38,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M38.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M38.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M38.jpg"
      },
      {
        id: 39,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M39.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M39.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M39.jpg"
      },
      {
        id: 40,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M40.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M40.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M40.jpg"
      },
      {
        id: 41,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M41.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M41.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M41.jpg"
      },
      {
        id: 42,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M42.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M42.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M42.jpg"
      },
      {
        id: 43,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M43.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M43.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M43.jpg"
      },
      {
        id: 44,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M44.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M44.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M44.jpg"
      },
      {
        id: 45,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M45.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M45.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M45.jpg"
      },
      {
        id: 46,
        title: { english: "", marathi: "" },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/M46.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/M46.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/M46.jpg"
      }
    ]
  },
  {
    id: 2,
    title: {
      english: "Kamgar Bhushan Awards 2015 and 2017",
      marathi: "कामगार भूषण पुरस्कार २०१५ आणि २०१७"
    },
    year: 2021,
    photos: [
      {
        id: 1,
        title: {
          english: "Kamgar Bhushan Award - 2015, Mr. Mahesh Yashwantrao Sewlikar, Bajaj Auto Ltd. Bajajnagar, Waluj, Aurangabad",
          marathi: "कामगार भूषण पुरस्कार - २०१५, श्री. महेश यशवंतराव सेवलीकर, बजाज ऑटो लि. बजाजनगर, वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2015.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2015.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2015.jpg"
      },
      {
        id: 2,
        title: {
          english: "Kamgar Bhushan Award - 2017, Mr. Vijay Bhupal Pise, Kirloskar Brothers Ltd. Tal. Palus Dist. Sangli",
          marathi: "कामगार भूषण पुरस्कार - २०१७, श्री. विजय भूपाल पिसे, किर्लोस्कर ब्रदर्स लि. ता. पलुस जि. सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2017.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2017.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/kamgar_bhushan_2017.jpg"
      }
    ]
  },
  {
    id: 3,
    title: {
      english: "Meritorious Worker Welfare Award - 2015",
      marathi: "गुणवंत कामगार कल्याण पुरस्कार - २०१५"
    },
    year: 2021,
    photos: [
      {
        id: 1,
        title: {
          english: "Mr. Anant Vasantrao Vakure, National Chemical & Fertilizers, Thal, Raigad",
          marathi: "श्री. अनंत वसंतराव वाकुरे राष्ट्रीय केमिकल अँड फर्टिलायझसि, थळ, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-01.jpg"
      },
      {
        id: 2,
        title: {
          english: "Mr. Rajesh Vasant Mesri, National Chemical & Fertilizers, Chembur, Mumbai",
          marathi: "श्री. राजेश वसंत मेस्री राष्ट्रीय केमिकल अँड फर्टिलायझर्स, चेंबूर, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-02.jpg"
      },
      {
        id: 3,
        title: {
          english: "Mr. Sukhdev Namdev Suryavanshi, Bajaj Auto Ltd., Waluj, Aurangabad",
          marathi: "श्री. सुखदेव नामदेव सूर्यवंशी बजाज ऑटो लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-03.jpg"
      },
      {
        id: 4,
        title: {
          english: "Mr. Vikas Shivaji Kore, Kirloskar Oil Engines Ltd., Khadki, Pune",
          marathi: "श्री. विकास शिवाजी कोरे किर्लोस्कर ऑईल इंजिन्स लि., खडकी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-04.jpg"
      },
      {
        id: 5,
        title: {
          english: "Mr. Jitendra Madhukar Kulkarni, Bajaj Auto Ltd., Waluj, Aurangabad",
          marathi: "श्री. जितेंद्र मधुकर कुलकर्णी बजाज ऑटो लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-05.jpg"
      },
      {
        id: 6,
        title: {
          english: "Mr. Arjun Ganpati Pawar, Kranti Agrani Dr. G. D. Bapu Lad Cooperative Sugar Factory Ltd., Palus, Sangli",
          marathi: "श्री. अर्जुन गणपती पवार क्रांती अग्रणी डॉ. जी. डी .बापू लाड सहकारी साखर कारखाना लि., पलूस, सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-06.jpg"
      },
      {
        id: 7,
        title: {
          english: "Mr. Shrikrishna Shaligram Arakharav, Maharashtra State Power Generation Company Ltd., Eklahere, Nashik",
          marathi: "श्री. श्रीकृष्ण शालीग्राम अरखराव महाराष्ट्र राज्य वीज निर्मिती कंपनी लि., एकलहरे, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-07.jpg"
      },
      {
        id: 8,
        title: {
          english: "Mrs. Rajalakshmi Sanjay Surve, Maharashtra State Road Transport Corporation, Ratnagiri",
          marathi: "सौ. राजलक्ष्मी संजय सुर्वे महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, रत्नागिरी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-08.jpg"
      },
      {
        id: 9,
        title: {
          english: "Mrs. Alka Rajendra Karnik, Maharashtra State Road Transport Corporation, Chikhalthana, Aurangabad",
          marathi: "सौ. अलका राजेंद्र कर्णिक महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, चिखलठाणा, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-09.jpg"
      },
      {
        id: 10,
        title: {
          english: "Mr. Bharat Sargerao Darade, Goodyear South Asia Tires Pvt. Ltd., Waluj, Aurangabad",
          marathi: "श्री. भरत सर्जेराव दराडे गुडईयर साउथ एशिया टायर्स प्रा.लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-10.jpg"
      },
      {
        id: 11,
        title: {
          english: "Mr. Dilip Ganpat Asabe, Aurangabad Electricals, Aurangabad",
          marathi: "श्री. दिलीप गणपत आसबे औरंगाबाद इलेक्ट्रिकल्स, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-11.jpg"
      },
      {
        id: 12,
        title: {
          english: "Mr. Ravindra Balkrishna Kulkarni, G. K. N. Sinter Metals Pvt. Ltd., Pimpri, Pune",
          marathi: "श्री. रविंद्र बाळकृष्ण कुलकर्णी जी. के. एन. सिंटर मेटल्स प्रा. लि., पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-12.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-12.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-12.jpg"
      },
      {
        id: 13,
        title: {
          english: "Mr. Prabhakar Gangaram Lahane, Maharashtra State Power Distribution Company Ltd., Washim",
          marathi: "श्री. प्रभाकर गंगाराम लहाने महाराष्ट्र राज्य वीज वितरण कंपनी लि., वाशीम"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-13.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-13.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-13.jpg"
      },
      {
        id: 14,
        title: {
          english: "Mr. Ambadas Eknathrao Devraye, Wokhardt Ltd., Chikhalthana, Aurangabad",
          marathi: "श्री. अंबादास एकनाथराव देवराये वोखार्ड लि., चिकलठाणा, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-14.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-14.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-14.jpg"
      },
      {
        id: 15,
        title: {
          english: "Mr. Balsahab Shamrao Dere, Ferrero India Pvt. Ltd., Baramati",
          marathi: "श्री. बाळसाहेब शामराव डेरे फेरेरो इंडिया प्रा. लि., बारामती"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-15.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-15.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-15.jpg"
      },
      {
        id: 16,
        title: {
          english: "Mr. Vinayak Datatray Pathare, Orient Blackkhana Pvt. Ltd., Fort, Mumbai",
          marathi: "श्री. विनायक दतात्रय पाठारे ओरिएंट ब्लॅकखान प्रा. लि., फोर्ट, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-16.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-16.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-16.jpg"
      },
      {
        id: 17,
        title: {
          english: "Mr. Dattaram Vitthal Jadhav, The Leela Hotel, Andheri, Mumbai",
          marathi: "श्री. दत्ताराम विठ्ठल जाधव दि लिला हॉटेल, अंधेरी, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-17.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-17.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-17.jpg"
      },
      {
        id: 18,
        title: {
          english: "Mr. Ravindra Jayram Chaudhari, Maharashtra State Road Transport Corporation, Dhule",
          marathi: "श्री. रविंद्र जयराम चौधरी महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, धुळे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-18.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-18.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-18.jpg"
      },
      {
        id: 19,
        title: {
          english: "Mr. Balasahab Hindurao Kambale, Maharashtra State Road Transport Corporation, Kolhapur",
          marathi: "श्री. बाळासाहेब हिंदुराव कांबळे महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-19.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-19.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-19.jpg"
      },
      {
        id: 20,
        title: {
          english: "Mr. Kedari Tipanna Akivad, Kirloskar Brothers, Kirloskarvadi, Sangli",
          marathi: "श्री. केदारी तिपण्णा अकिवाड किर्लोस्कर ब्रदर्स, किर्लोस्करवाडी, सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-20.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-20.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-20.jpg"
      },
      {
        id: 21,
        title: {
          english: "Mr. Gunavant Hanmantrao Misalwad, Maharashtra State Road Transport Corporation, Nanded",
          marathi: "श्री. गुणवंत हनमंतराव मिसलवाड महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, नांदेड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-21.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-21.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-21.jpg"
      },
      {
        id: 22,
        title: {
          english: "Mr. Lileshwar Manikrao Bansod, Maharashtra State Power Distribution Company Ltd., Thane",
          marathi: "श्री. लिलेश्वर माणिकराव बन्सोड महाराष्ट्र राज्य वीज वितरण कंपनी लि., ठाणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-22.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-22.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-22.jpg"
      },
      {
        id: 23,
        title: {
          english: "Mr. Balkrishna Mahadev Gopale, Wanaaz Engineers Ltd., Kothrud, Pune",
          marathi: "श्री. बाळकृष्ण महादेव गोपाळे वनाझ इंजिनिअर्स लि., कोथरूड, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-23.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-23.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-23.jpg"
      },
      {
        id: 24,
        title: {
          english: "Mr. Dadabhau Jaywant Gavde, Mahindra Sanyo Special Steel Company Ltd., Khalapur, Raigad",
          marathi: "श्री. दादाभाऊ जयवंत गावडे महिंद्रा सॅनियो स्पे. स्टील कंपनी लि., खालापूर, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-24.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-24.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-24.jpg"
      },
      {
        id: 25,
        title: {
          english: "Mr. Sanjay Jivan Salunkhe, Lokmanya Hospital, Nigdi",
          marathi: "श्री. संजय जीवन साळुंखे लोकमान्य हॉस्पिटल, निगडी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-25.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-25.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-25.jpg"
      },
      {
        id: 26,
        title: {
          english: "Mr. Pravin Jagannath Bahirat, National Chemical & Fertilizers, Chembur, Mumbai",
          marathi: "श्री. प्रविण जगन्नाथ बहिरट राष्ट्रीय केमिकल अँड फर्टिलायझर्स, चेंबूर, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-26.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-26.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-26.jpg"
      },
      {
        id: 27,
        title: {
          english: "Mr. Dinesh Namdev Jagatap, Haffkine Bio-Pharmaceutical Corporation, Parel, Mumbai",
          marathi: "श्री. दिनेश नामदेव जगताप हाफकिन जीव–औषध निर्माण महामंडळ, परेल, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-27.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-27.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-27.jpg"
      },
      {
        id: 28,
        title: {
          english: "Mr. Sandeep Babu Bari, Mahindra & Mahindra Ltd., Kandivali, Mumbai",
          marathi: "श्री. संदीप बाबू बारी महिंद्रा अँड महिंद्रा लि., कांदिवली, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-28.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-28.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-28.jpg"
      },
      {
        id: 29,
        title: {
          english: "Mr. Dharamendra Gulab Kannake, Chandrapur Super Thermal Power Station, Chandrapur",
          marathi: "श्री. धर्मेंद्र गुलाब कन्नाके चंद्रपूर महाऔष्णिक विद्युत केंद्र, चंद्रपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-29.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-29.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-29.jpg"
      },
      {
        id: 30,
        title: {
          english: "Mr. Nilkanth Hanjari Rathod, Richa Engineers Pvt. Ltd., Waluj, Aurangabad",
          marathi: "श्री. निलकंठ हंजारी राठोड ऋचा इंजिनिअर्स प्रा.लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-30.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-30.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-30.jpg"
      },
      {
        id: 31,
        title: {
          english: "Mr. Sunil Sabaji Kute, Mahindra C.I.E. Automotive Ltd., Bhosari, Pune",
          marathi: "श्री. सुनील सबाजी कुटे महिंद्रा सी.आय.ई ऑटोमोटिव्ह लि., भोसरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-31.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-31.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-31.jpg"
      },
      {
        id: 32,
        title: {
          english: "Mr. Abasahab Bhaskar Gayakwad, Maharashtra State Road Transport Corporation, Sangli",
          marathi: "श्री. आबासाहेब भास्कर गायकवाड महाराष्ट्र राज्य मार्ग परिवह महामंडळ, सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-32.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-32.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-32.jpg"
      },
      {
        id: 33,
        title: {
          english: "Mr. Kishorkumar Eknath Shinde, S.K.F. (India) Ltd., Chinchwad, Pune",
          marathi: "श्री. किशोरकुमार एकनाथ शिंदे एस.के.एफ. (इंडिया) लि., चिंचवड, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-33.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-33.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-33.jpg"
      },
      {
        id: 34,
        title: {
          english: "Mr. Dattatray Namdev Yelvande, Spaco Technologies Inc. Ltd., Chinchwad, Pune",
          marathi: "श्री. दत्तात्रय नामदेव येळवंडे स्पॅको टेक्नॉलॉजीस इं. लि ., चिंचवड, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-34.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-34.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-34.jpg"
      },
      {
        id: 35,
        title: {
          english: "Mr. Sheikh Abdul Saleem Abdulrazak, Maharashtra State Road Transport Corporation, Nanded",
          marathi: "श्री. शेख अब्दुल सलीम अब्दुलरजाक महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, नांदेड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-35.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-35.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-35.jpg"
      },
      {
        id: 36,
        title: {
          english: "Mr. Yogesh Baburao Barve, Maharashtra State Power Distribution Company, Nashik",
          marathi: "श्री. योगेश बाबुराव बर्वे महाराष्ट्र राज्य वीज वितरण कंपनी, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-36.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-36.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-36.jpg"
      },
      {
        id: 37,
        title: {
          english: "Mr. Shrikant Annasahab Patil, Manugraph India Ltd., Kolhapur",
          marathi: "श्री. श्रीकांत अण्णासाहेब पाटील मनुग्राफ इंडिया लि., कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-37.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-37.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-37.jpg"
      },
      {
        id: 38,
        title: {
          english: "Mr. Nilesh Balaram Patil, Tata Steel C. A. S. C., Tarapur, Palghar",
          marathi: "श्री. निलेश बाळाराम पाटील टाटा स्टील सी. आस. सी. तारापूर, पालघर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-38.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-38.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-38.jpg"
      },
      {
        id: 39,
        title: {
          english: "Mr. Ramkrishna Baburao Bo-hade, Mahindra & Mahindra, Kandivali, Mumbai",
          marathi: "श्री. रामकृष्ण बाबुराव बो-हाडे महिंद्रा अँड महिंद्रा, कांदिवली, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-39.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-39.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-39.jpg"
      },
      {
        id: 40,
        title: {
          english: "Mr. Rajesh Gorakh Sonar, Maharashtra State Road Transport Corporation, Dhule",
          marathi: "श्री. राजेश गोरख सोनार महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, धुळे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-40.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-40.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-40.jpg"
      },
      {
        id: 41,
        title: {
          english: "Mr. Krishna Sukhdev Dhokale, Haffkine Bio-Pharmaceutical Corporation, Pimpri, Pune",
          marathi: "श्री. कृष्णा सुखदेव ढोकले हाफकिन जीव –औषध निर्माण महामंडळ, पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-41.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-41.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-41.jpg"
      },
      {
        id: 42,
        title: {
          english: "Mr. Dattatray Narayan Mantinwar, Government Printing Press & Library, Nagpur",
          marathi: "श्री. दत्तात्रय नारायण मंतिनवार शासकिय मुद्रणालय व ग्रंथागार, नागपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-42.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-42.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-42.jpg"
      },
      {
        id: 43,
        title: {
          english: "Mr. Ranjitsing Indrasing Girase, Universal Starch Chem. Oil Ltd., Dhule",
          marathi: "श्री. रणजितसिंग इंद्रसिंग गिरासे युनिव्हर्सल स्टर्च केम. ऑईल लि., धुळे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-43.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-43.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-43.jpg"
      },
      {
        id: 44,
        title: {
          english: "Mr. Shrikant Madhav Bhute, S. K. F. (India) Ltd., Chinchwad, Pune",
          marathi: "श्री. श्रीकांत माधव भुते एस. के. एफ. (इंडिया) लि., चिंचवड, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-44.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-44.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-44.jpg"
      },
      {
        id: 45,
        title: {
          english: "Mr. Mahesh Krishna Mestry, Tata Motors Ltd., Pimpri, Pune",
          marathi: "श्री. महेश कृष्णा मेस्त्री टाटा मोटर्स लि., पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-45.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-45.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-45.jpg"
      },
      {
        id: 46,
        title: {
          english: "Mrs. Aastha Ajay Dalvi, Shushrusha Citizens Co-op. Hospital Ltd., Dadar, Mumbai",
          marathi: "सौ. आस्था अजय दळवी शुश्रुषा सिटीझन्स को-ऑप. हॉस्पिटल लि., दादर, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-46.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-46.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-46.jpg"
      },
      {
        id: 47,
        title: {
          english: "Mr. Satish Ramchandrarao Deshpande, Garware Polyester Ltd., Chikhalthana, Aurangabad",
          marathi: "श्री. सतीश रामचंद्रराव देशपांडे गरवारे पोलिएस्टर लि., चिकलठाणा, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-47.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-47.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-47.jpg"
      },
      {
        id: 48,
        title: {
          english: "Mr. Gurudev Shivaji Sarode, I. S. M. T. Ltd., Baramati, Pune",
          marathi: "श्री. गुरुदेव शिवाजी सरोदे आय. एस. एम. टी. लि., बारामती, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-48.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-48.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-48.jpg"
      },
      {
        id: 49,
        title: {
          english: "Mr. Vasant Lakshman Chiplunkar, J. K. Files (India) Ltd., Chiplun, Ratnagiri",
          marathi: "श्री. वसंत लक्ष्मण चिपळूणकर जे. के. फाईल्स (इंडिया) लि., चिपळूण, रत्नागिरी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-49.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-49.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-49.jpg"
      },
      {
        id: 50,
        title: {
          english: "Mr. Hanmant Kisan Mali, Tata Motors, Pimpri, Pune",
          marathi: "श्री. हनमंत किसन माळी टाटा मोटर्स, पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-50.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-50.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2015/2015-50.jpg"
      }
    ]
  },
  {
    id: 4,
    title: {
      english: "Meritorious Worker Welfare Award - 2017",
      marathi: "गुणवंत कामगार कल्याण पुरस्कार - २०१७"
    },
    year: 2021,
    photos: [
      {
        id: 1,
        title: {
          english: "Mr. Bhaskar Namdev Patil, Reliance Industries Ltd., Nagothane, Raigad",
          marathi: "श्री. भास्कर नामदेव पाटील, रिलायन्स इंडस्ट्रीज लि., नागोठणे, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-01-01.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-01-01.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-01-01.jpg"
      },
      {
        id: 2,
        title: {
          english: "Mr. Prakash Ratnu Bait, Government of India Mint, Mumbai",
          marathi: "श्री. प्रकाश रत्नू बाईत, भारत सरकार टांकसाळ, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-02.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-02.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-02.jpg"
      },
      {
        id: 3,
        title: {
          english: "Mr. Sandeep Dattatray Pansare, Mahindra C. I. E. Automotive Ltd., Maval, Pune",
          marathi: "श्री. संदीप दत्तात्रय पानसरे, महिंद्रा सी. आय. ई ऑटोमोटिव्ह लि., मावळ, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-03.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-03.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-03.jpg"
      },
      {
        id: 4,
        title: {
          english: "Mrs. Jayshree Sanjay Pandit, Maharashtra Jeevan Pradhikaran, Belapur, Navi Mumbai",
          marathi: "श्रीमती जयश्री संजय पंडित, महाराष्ट्र जीवन प्राधिकरण, बेलापूर, नवी मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-04.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-04.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-04.jpg"
      },
      {
        id: 5,
        title: {
          english: "Mrs. Sangita Girish Phuke, Maharashtra State Road Transport Corporation, Nashik",
          marathi: "श्रीमती संगीता गिरीश फुके, महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-05.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-05.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-05.jpg"
      },
      {
        id: 6,
        title: {
          english: "Mr. Sachin Rajaram Anpat, Satara District Central Cooperative Bank Ltd., Satara",
          marathi: "श्री. सचिन राजाराम अनपट, सातारा जिल्हा मध्यवर्ती सहकारी बँक लि., सातारा"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-06.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-06.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-06.jpg"
      },
      {
        id: 7,
        title: {
          english: "Mr. Sharad Giridhar Patil, National Chemical & Fertilizer Ltd., Thal, Raigad",
          marathi: "श्री. शरद गिरधर पाटील, राष्ट्रीय केमिकल अँड फर्टिलायझर लि., थळ, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-07.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-07.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-07.jpg"
      },
      {
        id: 8,
        title: {
          english: "Mr. Sopan Abasahab Bangar, Bajaj Auto Ltd., Waluj, Aurangabad",
          marathi: "श्री. सोपान आबासाहेब बांगर, बजाज ऑटो लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-08.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-08.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-08.jpg"
      },
      {
        id: 9,
        title: {
          english: "Mr. Suresh Shankar Nikam, Interval Poonawala Ltd., Hadapsar, Pune",
          marathi: "श्री. सुरेश शंकर निकम, इंटरव्हॉल्व पूनावाला लि., हडपसर, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-09.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-09.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-09.jpg"
      },
      {
        id: 10,
        title: {
          english: "Mr. Dattatray Sonba Mulik, Mahindra & Mahindra, Kandivali, Mumbai",
          marathi: "श्री. दत्तात्रय सोनबा मुळीक, महिंद्रा अँड महिंद्रा, कांदिवली, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-10.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-10.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-10.jpg"
      },
      {
        id: 11,
        title: {
          english: "Mrs. Rupali Bharat Konde, Godrej & Boyce Manufacturing Company Ltd., Shirval, Satara",
          marathi: "श्रीमती रुपाली भरत कोंडे, गोदरेज अँड बॉईज मॅन्यु. कंपनी लि., शिरवळ, सातारा"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-11.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-11.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-11.jpg"
      },
      {
        id: 12,
        title: {
          english: "Mr. Shrikant Trimbakrao More, Bajaj Auto Ltd., Waluj, Aurangabad",
          marathi: "श्री. श्रीकांत त्रिंबकराव मोरे, बजाज ऑटो लि., वाळूज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-12.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-12.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-12.jpg"
      },
      {
        id: 13,
        title: {
          english: "Mr. Dilip Ganpat Khond, V. V. F. (India) Ltd., Talaja, Raigad",
          marathi: "श्री. दिलीप गणपत खोंड, व्ही. व्ही. एफ. (इंडिया) लि., तळोजा, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-13.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-13.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-13.jpg"
      },
      {
        id: 14,
        title: {
          english: "Mr. Krishna Fakirchandji Gaygole, Maharashtra State Power Distribution Company, Amravati",
          marathi: "श्री. कृष्णा फकीरचंदजी गायगोले, महाराष्ट्र राज्य वीज वितरण कंपनी, अमरावती"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-14.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-14.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-14.jpg"
      },
      {
        id: 15,
        title: {
          english: "Mr. Subhash Dagadu Deshmukh, Foundation Brakes Manufacturing Pvt. Ltd., Jalgaon",
          marathi: "श्री. सुभाष दगडू देशमुख, फाऊंडेशन ब्रेक्स मॅन्यु. प्रा. ली, जळगाव"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-15.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-15.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-15.jpg"
      },
      {
        id: 16,
        title: {
          english: "Mr. Shivaji Rajaram Shinde, Life Insurance Corporation of India, Chiplun, Ratnagiri",
          marathi: "श्री. शिवाजी राजाराम शिंदे, भारतीय आयुर्विमा महामंडळ, चिपळूण, रत्नागिरी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-16.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-16.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-16.jpg"
      },
      {
        id: 17,
        title: {
          english: "Mr. Anandarao Hiraman Sonvane, Maharashtra State Power Distribution Company Ltd., Nandurbar",
          marathi: "श्री. आनंदराव हिरामण सोनवणे, महाराष्ट्र राज्य वीज वितरण कंपनी लि., नंदुरबार"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-17.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-17.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-17.jpg"
      },
      {
        id: 18,
        title: {
          english: "Mr. Ganesh Gulab Tamboli, Fins Frozen Foods (India) Ltd., Sinnar, Nashik",
          marathi: "श्री. गणेश गुलाब तांबोळी, फिन्स फ्रोझन फुड्स (इंडीया) लि., सिन्नर, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-18.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-18.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-18.jpg"
      },
      {
        id: 19,
        title: {
          english: "Mr. Dattaram Tukaram Fope, Bank of Maharashtra, Mahalaxmi, Mumbai",
          marathi: "श्री. दत्ताराम तुकाराम फोपे, बँक ऑफ महाराष्ट्र, महालक्ष्मी, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-19.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-19.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-19.jpg"
      },
      {
        id: 20,
        title: {
          english: "Mr. Rohit Sharad Kanade, India Security Press, Nashik Road",
          marathi: "श्री. रोहित शरद कानडे, भारत प्रतिभूती मुद्रणालय, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-20.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-20.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-20.jpg"
      },
      {
        id: 21,
        title: {
          english: "Mr. Ulhas Sitaram Deshmukh, Ajanta Pharma Ltd., Waluj, Aurangabad",
          marathi: "श्री. उल्हास सिताराम देशमुख, अजंता फार्मा लि., वाळूंज, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-21.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-21.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-21.jpg"
      },
      {
        id: 22,
        title: {
          english: "Mr. Ravindra Hanumant Chavan, Kalyan Carpenter Special Steel Pvt. Ltd., Mundhwa, Pune",
          marathi: "श्री. रविंद्र हनुमंत चव्हाण, कल्याणी कारपेंटर स्पेशल स्टील प्रा. लि., मुंढवा, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-22.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-22.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-22.jpg"
      },
      {
        id: 23,
        title: {
          english: "Mr. Sanjay Chandrakant Kadam, Konkan Mercantile Co-op. Ltd., Mazgaon, Mumbai",
          marathi: "श्री. संजय चंद्रकांत कदम, कोकण मर्कन्टाईल को. ऑप. लि., माझगाव, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-23.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-23.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-23.jpg"
      },
      {
        id: 24,
        title: {
          english: "Mr. Rohidas Lakshman Virkar, Mazgaon Dock Ship Builders Ltd., Mumbai",
          marathi: "श्री. रोहिदास लक्ष्मण विरकर, माझगाव डॉक शिप बिल्डर्स लि., मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-24.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-24.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-24.jpg"
      },
      {
        id: 25,
        title: {
          english: "Mr. Ashok Kashinath Bari (Fuse), The Supreme Industries Ltd., Jamner, Jalgaon",
          marathi: "श्री. अशोक काशिनाथ बारी (फुसे), दि सुप्रीम इंडस्ट्रीज लि., जामनेर, जळगाव"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-25.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-25.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-25.jpg"
      },
      {
        id: 26,
        title: {
          english: "Mr. Balwant Raghuji Thakre, Chandrapur Super Thermal Power Generation Center, Chandrapur",
          marathi: "श्री. बळवंत राघोजी ठाकरे, चंद्रपूर महाऔष्णिक विद्युत निर्मिती केंद्र, चंद्रपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-26.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-26.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-26.jpg"
      },
      {
        id: 27,
        title: {
          english: "Mr. Dattatray Pralhad Avsarkar, Tata Motors Company Ltd., Pimpri, Pune",
          marathi: "श्री. दत्तात्रय प्रल्हाद अवसरकर, टाटा मोटर्स कंपनी लि., पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-27.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-27.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-27.jpg"
      },
      {
        id: 28,
        title: {
          english: "Mr. Ramesh Haribhau Chandekar, Indrans Technology Ltd., Chakan, Pune",
          marathi: "श्री. रमेश हरिभाऊ चांदेकर, इंडरन्स टेक्नॉलॉजी लि., चाकण, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-28.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-28.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-28.jpg"
      },
      {
        id: 29,
        title: {
          english: "Mr. Dinkar Yadav Mashakhteri, Super Thermal Power Center, Chandrapur",
          marathi: "श्री. दिनकर यादव मशाखेत्री, महाऔष्णिक वीज केंद्र, चंद्रपूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-29.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-29.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-29.jpg"
      },
      {
        id: 30,
        title: {
          english: "Mr. Salimoddin Sheikh Karimoddin, Maharashtra State Road Transport Corporation, Kalmanuri, Hingoli",
          marathi: "श्री. सलीमोद्दिन शेख करीमोद्दिन, महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, कळमनुरी, हिंगोली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-30.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-30.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-30.jpg"
      },
      {
        id: 31,
        title: {
          english: "Mr. Suresh Daulatarao Panskar, Kirloskar Brothers Limited, Palus, Sangli",
          marathi: "श्री. सुरेश दौलतराव पानस्कर, किर्लोस्कर ब्रदर्स लिमिटेड, पलूस, सांगली"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-31.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-31.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-31.jpg"
      },
      {
        id: 32,
        title: {
          english: "Mr. Anand Mukundarao Jagirdar, Maharashtra State Road Transport Corporation, Akola",
          marathi: "श्री. आनंद मुकुंदराव जागीरदार, महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, अकोला"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-32.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-32.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-32.jpg"
      },
      {
        id: 33,
        title: {
          english: "Mr. Babasahab Gyanadev Bhorakad, Advance Enzyme Technologies Ltd., Sinnar, Nashik",
          marathi: "श्री. बाबासाहेब ज्ञानदेव भोरकड, अॅडव्हान्स एन्झाइम टेक्नॉलॉजीस लि., सिन्नर, नाशिक"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-33.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-33.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-33.jpg"
      },
      {
        id: 34,
        title: {
          english: "Mr. Satappa Mahadev Sutar, Jawahar Shetkari Cooperative Sugar Factory Ltd., Hupari, Kolhapur",
          marathi: "श्री. साताप्पा महादेव सुतार, जवाहर शेतकरी सहकारी साखर कारखाना लि., हुपरी, कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-34.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-34.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-34.jpg"
      },
      {
        id: 35,
        title: {
          english: "Mr. Gyaneshwar Balu Jundre, India Security Press, Nashik Road",
          marathi: "श्री. ज्ञानेश्वर बाळू जुंद्रे, इंडिया सिक्युरिटी प्रेस, नाशिक रोड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-35.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-35.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-35.jpg"
      },
      {
        id: 36,
        title: {
          english: "Mr. Sandeep Raghunath Pachange, Maharashtra State Power Distribution Company Limited, Dhule",
          marathi: "श्री. संदीप रघुनाथ पाचंगे, महाराष्ट्र राज्य वीज वितरण कंपनी मर्यादित, धुळे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-36.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-36.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-36.jpg"
      },
      {
        id: 37,
        title: {
          english: "Mr. Kishan Vitthalrao Shirkekar, Maharashtra State Road Transport Corporation, Parbhani",
          marathi: "श्री. किशन विठ्ठलराव शिर्लेकर, महाराष्ट्र राज्य मार्ग परिवहन महामंडळ, परभणी"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-37.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-37.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-37.jpg"
      },
      {
        id: 38,
        title: {
          english: "Mr. Shankar Dattatray Nanekar, M. P. Enterprises & Associates, Pune",
          marathi: "श्री. शंकर दत्तात्रय नाणेकर, एम. पी. इंटरप्रायजेस अँड असोसिएटस, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-38.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-38.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-38.jpg"
      },
      {
        id: 39,
        title: {
          english: "Mr. Ismail Nasruddin Mulla, Tata Motors Company Ltd., Pimpri, Pune",
          marathi: "श्री. इस्माईल नसरुद्दिन मुल्ला, टाटा मोटर्स कंपनी लि. पिंपरी, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-39.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-39.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-39.jpg"
      },
      {
        id: 40,
        title: {
          english: "Mr. Shivram Manohar Gavas, Simmond Marshall Ltd., Pune",
          marathi: "श्री. शिवराम मनोहर गवस, सिमंड मार्शल लि., पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-40.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-40.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-40.jpg"
      },
      {
        id: 41,
        title: {
          english: "Mr. Balasahab Aburao Barvakar, Jubilant Life Sciences Company Ltd., Pune",
          marathi: "श्री. बाळासाहेब आबुराव बारवकर, ज्युबिलियंट लाईफ सायन्सेस कंपनी लि., पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-41.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-41.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-41.jpg"
      },
      {
        id: 42,
        title: {
          english: "Mr. Gajanan Nathu Patil, National Chemical & Fertilizer Ltd., Thal, Raigad",
          marathi: "श्री. गजानन नथू पाटील, राष्ट्रीय केमिकल अँड फर्टिलायझर लि., थळ, रायगड"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-42.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-42.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-42.jpg"
      },
      {
        id: 43,
        title: {
          english: "Mr. Rakesh Anant Sawant, Wanaaz Engineers Ltd., Kothrud, Pune",
          marathi: "श्री. राकेश अनंत सावंत, वनाझ इंजिनिअर्स लि., कोथरूड, पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-43.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-43.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-43.jpg"
      },
      {
        id: 44,
        title: {
          english: "Mrs. Sangita Shrikant Jogdand, Dharmveer Sambhaji Urban Co-op. Bank Ltd., Pune",
          marathi: "श्रीमती संगीता श्रीकांत जोगदंड, धर्मवीर संभाजी अर्बन को-ऑप. बँक लि., पुणे"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-44.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-44.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-44.jpg"
      },
      {
        id: 45,
        title: {
          english: "Mr. Govind Shivram Jadhav, ACG Associated Capsules Pvt. Ltd., Shirval, Satara",
          marathi: "श्री. गोविंद शिवराम जाधव, एसीजी असोसिएटेड कॅप्सुल्स प्रा. लि., शिरवळ, सातारा"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-45.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-45.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-45.jpg"
      },
      {
        id: 46,
        title: {
          english: "Mr. Sharad Baburao Siras, H. M. T. Ltd., Chikhalthana, Aurangabad",
          marathi: "श्री. शरद बाबुराव सिरस, एच. एम. टी. लि., चिखलठाणा, औरंगाबाद"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-46.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-46.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-46.jpg"
      },
      {
        id: 47,
        title: {
          english: "Mr. Sameer Lakshman Lad, Mazgaon Dock Ltd., Mazgaon, Mumbai",
          marathi: "श्री. समीर लक्ष्मण लाड, माझगाव डॉक लि., माझगाव, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-47.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-47.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-47.jpg"
      },
      {
        id: 48,
        title: {
          english: "Mr. Gopinath Rajaram Jagatap, Maharashtra State Power Distribution Company Ltd., Bandra, Mumbai",
          marathi: "श्री. गोपीनाथ राजाराम जगताप, महाराष्ट्र राज्य विद्युत वितरण कंपनी लि., बांद्रा, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-48.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-48.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-48.jpg"
      },
      {
        id: 49,
        title: {
          english: "Mr. Arun Lakshmanrao Bhosle, National Chemical & Fertilizer Ltd., Chembur, Mumbai",
          marathi: "श्री. अरुण लक्ष्मणराव भोसले, राष्ट्रीय केमिकल अँड फर्टिलायझर लि., चेंबूर, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-49.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-49.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-49.jpg"
      },
      {
        id: 50,
        title: {
          english: "Mr. Dattaprasad Ramchandra Shirodkar, Johnson & Johnson Pvt. Ltd., Mulund, Mumbai",
          marathi: "श्री. दत्तप्रसाद रामचंद्र शिरोडकर, जॉन्सन अँड जॉन्सन प्रा. लि., मुलुंड, मुंबई"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-50.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-50.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-50.jpg"
      },
      {
        id: 51,
        title: {
          english: "Mr. Satish Sharadchandra Bedekar, Maharashtra State Power Distribution Company Ltd., Chiplun",
          marathi: "श्री. सतीश शरदचंद्र बेडेकर, महाराष्ट्र राज्य विद्युत वितरण कंपनी लि., चिपळूण"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-51.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-51.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-51.jpg"
      },
      {
        id: 52,
        title: {
          english: "Mr. Yogiraj Naththuji Ghotekar, Life Insurance Corporation of India, Amravati",
          marathi: "श्री. योगीराज नथ्थूजी घोटेकर, भारतीय जीवन बिमा निगम, अमरावती"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-52.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-52.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-52.jpg"
      },
      {
        id: 53,
        title: {
          english: "Mr. Suresh Shivaji Powar, Jawahar Shetkari Cooperative Sugar Factory, Kolhapur",
          marathi: "श्री. सुरेश शिवाजी पोवार, जवाहर शेतकरी सहकारी साखर कारखाना, कोल्हापूर"
        },
        image: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-53.webp",
        fallback: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-53.jpg",
        url: "https://mlwb.in/react-static-files/images/gallery/2021/2017/2017-53.jpg"
      }
    ]
  }
];

export default albums2021;

